export default {
  BASE_URL: '/paramConfig',
  api: [
    {
      name: 'listConfigTypes',
      method: 'GET',
      desc: '获取参数管理分类',
      path: '/listConfigTypes'
    },
    {
      name: 'delParam',
      method: 'POST',
      desc: '删除参数',
      path: '/delParam',
      append: true
    },
    {
      name: 'saveOrModifyParam',
      method: 'POST',
      desc: '新增/编辑参数',
      path: '/saveOrModifyParam'
    },
    {
      name: 'openOrCloseParam',
      method: 'POST',
      desc: '启用/禁用',
      path: '/openOrCloseParam'
    },
    {
      name: 'listConfigs',
      method: 'GET',
      desc: '参数列表',
      path: '/listConfigs'
    },
    {
      name: 'getConfig',
      method: 'GET',
      desc: '获取参数详情',
      path: '/getConfig',
      append: true
    }
  ]
}



// WEBPACK FOOTER //
// ./src/api/apis/cms/param.js